import { AppRouter } from './router/AppRouter';
import { VersionStamp } from './components/VersionStamp';

/**
 * App — the router host. With S-E3, App stops branching on auth state and
 * simply renders the route tree (AppRouter). The login surface, the
 * authenticated home, loading and error states now live in route-hosted
 * pages behind the <RequireAuth>/<RequireTenant> guards. Per-page chrome
 * (TopNav) is composed inside each page for now; a shared layout route
 * arrives with the Phase-5 shell.
 *
 * VersionStamp is rendered LAST (and is `position: fixed`, pointer-events
 * none) so the deployed build version sits unobtrusively in the corner of
 * every route without intercepting input or needing a z-index (D4-08).
 */
export function App() {
  return (
    <>
      <AppRouter />
      <VersionStamp />
    </>
  );
}
App.displayName = 'App';
